"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _blocks = require("@bueno/blocks");

var _sorting = require("../../utils/sorting");

var _Page = require("../Layout/Page");

var _InfoText = _interopRequireDefault(require("./components/InfoText"));

var _ActionBar = _interopRequireWildcard(require("./components/ActionBar"));

var _ListView = _interopRequireDefault(require("./components/ListView"));

var _ViewAction = require("../ActionModals/ViewAction");

var _context = require("../ActionModals/ViewAction/context");

var _ActionModals = require("../ActionModals");

/* eslint-disable no-eq-null */
const StyledFrame = (0, _styledComponents.default)(_blocks.Frame)`
  overflow: visible;
`;

function getAllStatuses(actions) {
  return new Set(actions.map(action => action.bonfire_status).filter(Boolean));
}

const Actions = ({
  activeActionId,
  closedOnStartDate,
  data,
  handleClosedActionsTimeFrameChange,
  history,
  numberOfSelectedSites,
  setActiveAction,
  sortDirection,
  sortFilter,
  onActionUpdate,
  status,
  updateHistory,
  userDisplayName
}) => {
  const {
    showModal
  } = (0, _context.useActions)();
  const {
    actionStatus
  } = (0, _context.useState)();
  const [filtered, setFiltered] = (0, _react.useState)([]);
  const [noResults, setNoResults] = (0, _react.useState)(false);
  const [showCreateForm, setShowCreateForm] = (0, _react.useState)(false);
  const [stringFilterQuery, setStringFilterQuery] = (0, _react.useState)(_queryStringForAll.default.parse(history.location.search)[_ActionBar.SEARCH_KEY]);

  const [statusFilterQuery, setStatusFilterQuery] = _react.default.useState(_queryStringForAll.default.parse(history.location.search)[_ActionBar.STATUS_FILTER_KEY]);

  const allStatuses = (0, _react.useMemo)(() => data != null ? getAllStatuses(data) : undefined, [data]);
  const [selectedStatus, setSelectedStatus] = (0, _react.useState)(new Set());
  (0, _react.useEffect)(() => {
    if (data === undefined) return; // handleSearch is called on mount, which populates `filtered`
    // so if data is defined, `filtered` will be as well (with query applied, if present)

    setFiltered((0, _sorting.sortActionData)(filtered, sortFilter, sortDirection));
  }, [data, sortFilter, sortDirection]);
  (0, _react.useEffect)(() => {
    if (activeActionId !== undefined && data !== undefined && (actionStatus === _context.Status.idle || actionStatus === _context.Status.ready)) {
      showModal(activeActionId, userDisplayName);
    }
  }, [activeActionId]);

  const updateQueryString = (key, newValue) => {
    const qs = _queryStringForAll.default.parse(history.location.search);

    const stringified = _queryStringForAll.default.stringify({ ...qs,
      [key]: newValue === '' ? undefined : newValue
    });

    history.replace({
      search: stringified
    });
    updateHistory();
  };

  const handleSearch = (0, _react.useCallback)(({
    filtered,
    query
  }) => {
    const searchString = query.length > 1 ? query : undefined;
    updateQueryString(_ActionBar.SEARCH_KEY, searchString);

    if (filtered.length === 0) {
      setNoResults(true);
      setStringFilterQuery(query);
      setFiltered([]);
      return;
    }

    const sorted = (0, _sorting.sortActionData)(filtered, sortFilter, sortDirection);
    setNoResults(false);
    setFiltered(sorted);
  }, [history, updateHistory, sortDirection, sortFilter]);
  const handleStatusFilterChange = (0, _react.useCallback)((option, checked) => {
    setSelectedStatus(prevState => {
      const clone = new Set(prevState);
      checked ? clone.add(option) : clone.delete(option); // This pattern is insanity, and the cause of multiple extremely
      // dangerous side effects.
      // I'd rather rewrite the entire page but it's not worth it anymore.

      const qs = [...clone].join(',');
      updateQueryString(_ActionBar.STATUS_FILTER_KEY, qs);
      setStatusFilterQuery(qs);
      return clone;
    });
  }, [selectedStatus]); // Load the selected statuses from the url if there are any. This is again a
  // super jank side effect pattern that exists in other places. There is no
  // unified URL sync pattern that isn't built on side effects.

  (0, _react.useEffect)(() => {
    if (allStatuses == null) return;
    if (Array.isArray(statusFilterQuery)) return;
    const queryStatuses = statusFilterQuery === null || statusFilterQuery === void 0 ? void 0 : statusFilterQuery.split(',');
    /** The set of statuses to be persisted to state */

    const newSet = new Set(); // if the incomingStatus list is empty, populate the selected statuses
    // with all available statuses

    if (queryStatuses == null) {
      allStatuses.forEach(status => newSet.add(status));
    } // otherwise only add the ones present in the url
    else {
        for (const status of queryStatuses) {
          if (allStatuses.has(status)) {
            newSet.add(status);
          }
        }
      }

    setSelectedStatus(newSet);
  }, [statusFilterQuery, allStatuses, data]);
  const handleClose = (0, _react.useCallback)(() => {
    setActiveAction(undefined);
  }, []);
  const handleRowClick = (0, _react.useCallback)(actionId => () => {
    setActiveAction(actionId);
  }, []);

  const handleActionUpdate = action => {
    if (onActionUpdate !== undefined) {
      onActionUpdate(action.key, action);
    }
  };

  const filteredByStatus = filtered.filter(action => selectedStatus.size === 0 || selectedStatus.has(action.bonfire_status));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Page.PageHeader, null, status !== undefined && /*#__PURE__*/_react.default.createElement(_InfoText.default, {
    numberOfSelectedSites: numberOfSelectedSites,
    status: status,
    active: filteredByStatus.length,
    closedOnStartDate: closedOnStartDate
  })), /*#__PURE__*/_react.default.createElement(_ActionBar.default, {
    history: history,
    initialSearch: stringFilterQuery,
    data: data,
    filteredData: filteredByStatus,
    noResults: noResults,
    onSearchStringChange: handleSearch,
    onCreateAction: () => setShowCreateForm(true),
    handleClosedActionsTimeFrameChange: handleClosedActionsTimeFrameChange,
    status: status,
    statusFilter: {
      options: [...(allStatuses !== null && allStatuses !== void 0 ? allStatuses : [])],
      selected: selectedStatus,
      onChange: handleStatusFilterChange
    }
  }), /*#__PURE__*/_react.default.createElement(StyledFrame, null, /*#__PURE__*/_react.default.createElement(_ListView.default, {
    rows: filteredByStatus,
    noResults: noResults,
    activeActionId: activeActionId,
    onRowClick: handleRowClick
  })), /*#__PURE__*/_react.default.createElement(_ViewAction.ViewAction, {
    onClose: handleClose,
    onActionChange: handleActionUpdate
  }), /*#__PURE__*/_react.default.createElement(_ActionModals.CreateAction, {
    isOpen: showCreateForm,
    onRequestClose: () => setShowCreateForm(false)
  }));
};

exports.Actions = Actions;